import React from 'react';
import { ShieldCheck, Lock, Factory } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const ICONS = [ShieldCheck, Lock, Factory];

export default function TrustSection() {
  const { t } = useLanguage();

  return (
    <section className="bg-white border-b border-ct-line py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12 lg:mb-16">
          <p className="text-[11px] font-bold uppercase tracking-widest text-ct-brand mb-3">
            {t.trust?.subtitle || 'Built to earn trust'}
          </p>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-black text-ct-ink tracking-tight"
            style={{ fontFamily: 'Chivo, sans-serif' }}
          >
            {t.trust.title}
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {t.trust.items.map((item, i) => {
            const Icon = ICONS[i] || ShieldCheck;
            return (
              <article
                key={i}
                className="ct-card-lift bg-white border border-ct-line rounded-ct-card p-7 ct-shadow-sm"
                data-testid={`trust-item-${i}`}
              >
                <div className="w-11 h-11 bg-ct-ink text-white flex items-center justify-center rounded-ct-chip mb-5">
                  <Icon className="w-5 h-5" strokeWidth={1.75} />
                </div>
                <h3
                  className="font-black text-ct-ink text-base tracking-tight mb-2"
                  style={{ fontFamily: 'Chivo, sans-serif' }}
                >
                  {item.title}
                </h3>
                <p className="text-sm text-ct-ink-2 leading-relaxed">{item.desc}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
